// extracted by mini-css-extract-plugin
module.exports = {"title":"PromotionsHero_title__0G85n"};